import React from 'react';
import Button from '@material-ui/core/Button';

export default (props) => (
    <Button variant="contained" color="primary" style={{minWidth: '300px', fontWeight:600}} {...props}>
        {props.children}
    </Button>
);